import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class PaymentModeServices {

  // creating PaymentMode
  createPaymentMode = async (payload) => {
    const createdPaymentMode = await Helpers.post({
      url: Constants.PAYMENT_ACCOUNTS,
      data: payload,
    });
    return createdPaymentMode;
  }

  // update PaymentMode
  updatePaymentMode = async (payload) => {
    const updatePaymentMode = await Helpers.put({
      url: Constants.PAYMENT_ACCOUNTS,
      data: payload,
    });
    return updatePaymentMode;
  }

  // get PaymentMode
  getPaymentMode = async (accountType) => {
    let url = `${Constants.PAYMENT_ACCOUNTS}?`;
    if (accountType) url += `account_type=${accountType}`;
    const PaymentMode = await Helpers.get({ url });
    return PaymentMode;
  }

  // delete PaymentMode
  deletePaymentMode = async (payload) => {
    const deletedPaymentMode = await Helpers.delete({
      url: Constants.PAYMENT_ACCOUNTS,
      data: payload,
    });
    return deletedPaymentMode;
  }
}

export default new PaymentModeServices();
